import { render, staticRenderFns } from "./UsuarioWrapper.vue?vue&type=template&id=fc85a518"
import script from "./UsuarioWrapper.vue?vue&type=script&lang=js"
export * from "./UsuarioWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports